import { Oauth_Authorize, postV1AuthOauthAuthorize } from '@treadinc/horizon-api-spec';
import { useCallback } from 'react';

export default function useOauthAuthorize() {
  const authorize = useCallback(async (body: Oauth_Authorize, signal?: AbortSignal) => {
    const response = await postV1AuthOauthAuthorize({ body, signal });

    return response.data.data.redirect_uri;
  }, []);

  return { authorize };
}
